import Button from '@material-ui/core/Button';

export default function CreateBack({ onCreate, onBack, createDisable, content }) {

    return (
        <>
            <Button onClick={onBack} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                Back
            </Button>
            <Button onClick={onCreate} color="primary" variant="contained" style={{ marginLeft: 10 }} disabled={createDisable}>
                {content !== undefined ? content : 'Create'}
            </Button>
        </>
    )
}